import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { SharedService } from '../../../../Services/shared.service';
import { Router, RouterModule } from '@angular/router';
import { DialogMychildComponent } from '../../../Home/Components/dialog-mychild/dialog-mychild.component';
import { Dialog } from '@angular/cdk/dialog';

@Component({
  selector: 'app-free-mock',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './free-mock.component.html',
  styleUrl: './free-mock.component.css'
})
export class FreeMockComponent {
  PREP_UserInfo: any = null;
  object: any;
  subjectList: any = [];
  PREP_ExamDetails: any;
  constructor(
    private _svc: SharedService,
    private _fb: FormBuilder,
    private _router: Router,
    private _dialog: Dialog
  ) {

  }
  get _form() { return this.object.controls }
  ngOnInit(): void {

    this._svc.get_Login_Status().subscribe(x => {
      this.PREP_UserInfo = x;
      this.GenerateForm();
    })

  this.subjectList = this._svc.SubjectLists().find((cls: any) => cls.classId === this.PREP_UserInfo?.classId)?.subjectList || [];
  this.PREP_ExamDetails = JSON.parse(localStorage.getItem('PREP_ExamDetails') || "{}");
  }
  GenerateForm() {
    this.object = this._fb.group({
      eventLetter: [null, [Validators.required]],
      childId: [this.PREP_UserInfo?.childId, [Validators.required]],
      childName: [this.PREP_UserInfo?.childName, [Validators.required]],
      classId: [this.PREP_UserInfo?.classId, [Validators.required]],
      isDisclaimer: [null, [Validators.required]]
    })

    this.setCustomValidation();
  }
  setCustomValidation() {

    const _isDisclaimer = this.object.get('isDisclaimer');

    this.object.get('isDisclaimer').valueChanges.subscribe((value: any) => {

      if (value == false) {
        _isDisclaimer.setValue(null);
      }
    });
  }

  Process() {
    debugger
    if (this.PREP_UserInfo.childId == null) {
      this._svc.Notification('error', 'Please add a child before starting the mock test.');
      return;
    }
    if (this.object.invalid) {
      this.object.markAllAsTouched();
      return;
    }


    var _subjectName = this.subjectList.filter((x: any) => x.eventLetter == this.object.value.eventLetter)[0].subjectName;
    localStorage.setItem('PREP_ExamDetails', JSON.stringify({ ChildId: this.object.value.childId, className: this.PREP_UserInfo.className, SubjectName: _subjectName, eventLetter: this.object.value.eventLetter, classId: this.object.value.classId, MockSet: 'Free Mock Test' }));
    this._router.navigate(['/required-configuration']);
  }

  Switch_Child() {
    this._svc.Switch_Child().then((res: any) => {
      this.ngOnInit();
    })
  }
}
